export default __webpack_public_path__ + "static/media/bg_desktop_min.dfcb88a0.jpg";